import { Result } from '../../../../../common/models/Result';
import { HttpServiceBase } from '../../../../../common/services/HttpServiceBase';

export class GetCustomerCashbackDetailsService extends HttpServiceBase {

    handle = (shopifyCustomerId: number, bearerToken: string): Promise<Result<GetCustomerCashbackDetailsOutput>|null> => {
        const promise = this.http.get<Result<GetCustomerCashbackDetailsOutput>>(
          `${this.baseUrlZerezesApi}/club-pdv/customer-cashback-details/${shopifyCustomerId}`,
          bearerToken);
        return promise;
    }
}

export class GetCustomerCashbackDetailsOutput {
  shopifyCustomerId: number;
  firstName: string;
  lastName: string;
  state: string;
  lastOrderDate?: Date | null;
  ordersCount?: number | null;
  cashbackExpiresAt?: Date | null;
  formattedCashbackExpiresAt?: string | null;
  couponCode?: string | null;
  discountValue?: number | null;
}